import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSettings, FiGift } = FiIcons;

function Header({ onSettings, onCelebrate }) {
  return (
    <header className="site-header">
      <div className="brand">
        <span className="brand-mark" aria-hidden="true">F</span>
        <div>
          <p className="wordmark">FERIENCOUNTDOWN</p>
          <p className="tagline">Dein kostenloser Motivator für den Schulalltag</p>
        </div>
      </div>

      <nav className="header-actions" aria-label="Schnellaktionen">
        <button className="button button-secondary" type="button" onClick={onSettings}>
          <SafeIcon icon={FiSettings} aria-hidden="true" />
          <span>Arbeitstage</span>
        </button>
        <button className="button button-primary" type="button" onClick={onCelebrate}>
          <SafeIcon icon={FiGift} aria-hidden="true" />
          <span>Freude</span>
        </button>
      </nav>
    </header>
  );
}

export default Header;